import { ContentProvider } from '#root/lib/content'
import { logger } from '#root/lib/logger'

export const contentProvider = new ContentProvider({
  cdn: import.meta.env.VITE_CONTENT_CDN,
  dev: import.meta.env.DEV,
  logger,
  origin: import.meta.env.VITE_CONTENT_ORIGIN
})
